/*
 * Copyright (c) 2018. CPP, Inc. All rights reserved.
 * Also protected by Patent Pending: 15/916,593
 */

function processDocument(data) {
  return {
    title: data.fields.title,
    html: data.html,
  }
}

export default processDocument
